module.exports = (s) => {
  return [
    {
      name: '渠道号',
      value: 'channel_alias',
    },
    {
      name: '原生锚点类型',
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: row.type.value,
              placeholder: '请选择',
            },
            on: {
              change: (type) => {
                row.type.value = type;
              },
            },
          },
          row.type.options.map(({ label, value }) => {
            return h('el-option', { props: { label, value }}, null);
          })
        );

        return ele;
      },
    },
    {
      name: '操作',
      format: (row) => {
        const h = s.$createElement;
        const type = row.type.value;

        return type ? h('div', { class: 'flex' }, [
          h(
            'el-select',
            {
              class: 'mr-10',
              props: {
                size: 'mini',
                value: row.target[type].value,
                placeholder: '请选择',
              },
              on: {
                change: (value) => {
                  row.target[type].value = value;
                },
              },
            },
            row.target[type].options.map(({ label, value }) => {
              return h('el-option', { props: { label, value }}, null);
            }),
          ),
        ]) : '-';
      },
    },
  ];
};
